<template>
    <div v-show="attractionList.length > 0">
        <h3 class="around-spot-text">周邊景點</h3>
        <ul v-show="!loading">
            <li v-for="l in attractionList" :key="l.id">
                <a
                    href=""
                    class="d-block"
                    @click.prevent="goAttractionsDetail(l.id)"
                >
                    <div class="list-card">
                        <div class="img-wrapper">
                            <vue-load-image>
                                <img
                                    slot="image"
                                    :src="`${apiPhotoUrl}/ori/${l.photoId}`"
                                    :alt="l.name"
                                />
                                <img
                                    slot="preloader"
                                    src="@/assets/image-loader.gif"
                                    class="w-100"
                                />
                                <img
                                    slot="error"
                                    class="border d-block bg-white"
                                    src=""
                                    alt="not found"
                                />
                            </vue-load-image>
                        </div>
                        <div class="card-body">
                            <div class="text-wrapper">
                                <div class="title" v-text="l.name">
                                    林之助紀念館
                                </div>
                                <div
                                    class="distance"
                                    v-show="l.distance !== undefined"
                                >
                                    <img
                                        src="@/assets/self_ic_map.png"
                                        alt="距離"
                                    />{{ l.distance }}m
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
        <div v-if="attractionList.length === 0">無</div>
        <button
            class="btn btn-more w-100 d-block my-3"
            @click="goAttractionsAround"
        >
            查看更多推薦
        </button>
        <Loader :show="loading"></Loader>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import coreMixin from '@/js/mixin/coreMixin';
import { getDistanceByPoint } from '@/js/map/tool';
import { apiAttractions } from '@/plugin/api';
import Loader from '@/components/Loader';

export default {
    props: {
        /**
         * 原點
         */
        origin: {
            type: [Array, Number],
            default: null,
        },
        /**
         * 河川ID
         */
        riverId: {
            type: String,
            require: true,
        },
    },
    data() {
        return {
            loading: false,
            paras: {
                keyword: '',
                currentPage: 1,
                pageSize: 10000,
            },
            attractionList: [],
        };
    },

    mounted() {
        this.getAttractions();
    },
    computed: {
        ...mapState('userData', ['currentPosition']),
    },
    methods: {
        goAttractionsDetail(id) {
            this.$router.push(`/guide/attractions/${id}`);
        },
        goAttractionsAround() {
            this.$router.push(`${this.$route.path}/around`);
        },
        async getAttractions() {
            const { riverId } = this;
            this.loading = true;
            await apiAttractions({ ...this.paras, riverId }).then((res) => {
                if (res.data.success) {
                    this.attractionList = res.data.data.map((item) => {
                        const distance = parseInt(
                            getDistanceByPoint(this.currentPosition, [
                                +item.longitude,
                                +item.latitude,
                            ]),
                            10,
                        );
                        return {
                            ...item,
                            lat: +item.latitude,
                            lon: +item.longitude,
                            name: item.name,
                            id: item.attractionId,
                            distance,
                        };
                    });
                    // 依距離作排序;
                    this.attractionList.sort((a, b) => {
                        const sortColumn = 'distance';
                        return a[sortColumn] - b[sortColumn];
                    });
                    this.attractionList = this.attractionList.slice(0, 3);
                }
            }, this.errorHandler);
            this.loading = false;
        },
    },
    components: {
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
